import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../dashboard/Sidebar';
import TopRightUser from '../dashboard/TopRightUser';
import NoIndex from '@/components/seo/NoIndex';
import { NotificationBell } from '../dashboard/NotificationBell';

const PAGE_TITLES: Record<string, string> = {
  '/dashboard': 'Tableau de bord',
  '/dashboard/compte': 'Mon compte',
  '/dashboard/candidature': 'Ma candidature',
  '/dashboard/support': 'Support',
  '/dashboard/notifications': 'Notifications',
  '/dashboard/ao/overview': 'Vue d\'ensemble',
  '/dashboard/ao/opportunites': 'Opportunités',
  '/dashboard/ao/commissions': 'Commissions',
  '/dashboard/ao/classement': 'Classement',
  '/dashboard/ao/affilies': 'Affiliés',
  '/dashboard/ao/parrainage': 'Parrainage',
  '/dashboard/collaborateur/overview': 'Vue d\'ensemble',
  '/dashboard/collaborateur/marques': 'Marques partenaires',
  '/dashboard/collaborateur/rendez-vous': 'Prendre rendez-vous',
  '/dashboard/collaborateur/documents': 'Documents',
};

export default function DashboardLayout() {
  const location = useLocation();
  const pageTitle = PAGE_TITLES[location.pathname] ?? 'Dashboard';
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-[#0a0a0a]">
      <NoIndex />
      
      {/* Sidebar desktop */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {/* Sidebar mobile avec overlay */}
      {sidebarOpen && (
        <>
          <div 
            className="fixed inset-0 bg-black/70 z-40 md:hidden animate-fade-in"
            onClick={() => setSidebarOpen(false)}
          />
          <div className="fixed inset-y-0 left-0 z-50 md:hidden animate-slide-in-left">
            <Sidebar onClose={() => setSidebarOpen(false)} />
          </div>
        </>
      )}

      <div className="flex-1 flex flex-col overflow-hidden w-full md:w-auto">
        <header className="bg-[#111111] border-b border-gray-800 px-4 md:px-8 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4 min-w-0 flex-1">
            <button
              onClick={() => setSidebarOpen(true)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-800 transition-colors flex-shrink-0"
              aria-label="Menu"
            >
              <i className="ri-menu-line text-xl text-white"></i>
            </button>
            <h2 className="text-lg font-semibold text-white truncate">{pageTitle}</h2>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <NotificationBell />
            <TopRightUser />
          </div>
        </header>
        <main className="flex-1 overflow-y-auto bg-[#0a0a0a]">
          <div className="p-4 md:p-6 lg:p-8">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}